
    <span class="k-button k-flat k-title k-calendar-title" [class.k-state-disabled]="!navigate"
        [kendoEventsOutsideAngular]="{
            click: handleNavigation
        }"
        [scope]="this">
        <ng-template [ngIf]="!templateRef">{{title}}</ng-template>
        <ng-template
            [ngIf]="templateRef"
            [ngTemplateOutlet]="templateRef"
            [ngTemplateOutletContext]="{ $implicit: title, activeView: activeViewValue, date: currentDate }"
        ></ng-template>
    </span>
    <span class="k-spacer"></span>
    <span class="k-calendar-nav k-hstack">
        <button
            *ngIf="showNavigationButtons"
            class="k-button k-flat k-icon-button k-prev-view"
            type="button"
            [attr.aria-disabled]="isPrevDisabled"
            [disabled]="isPrevDisabled"
            [title]="prevButtonTitle"
            (click)="prevButtonClick.emit()"
        >
            <span class="k-icon k-i-arrow-60-left"></span>
        </button>
        <span
            class="k-today k-nav-today"
            [class.k-state-disabled]="!todayAvailable"
            [kendoEventsOutsideAngular]="{
                click: handleTodayClick
            }"
            [scope]="this"
        >
            {{ todayMessage }}
        </span>
        <button
            *ngIf="showNavigationButtons"
            class="k-button k-flat k-icon-button k-next-view"
            type="button"
            [attr.aria-disabled]="isNextDisabled"
            [disabled]="isNextDisabled"
            [title]="nextButtonTitle"
            (click)="nextButtonClick.emit()"
        >
            <span class="k-icon k-i-arrow-60-right"></span>
        </button>
    </span>
  